import { getColorSchemeRegistry, getScale } from '@encodable/color';
import { getTimeFormatter, getTimeFormatterRegistry, LOCAL_TIME_PREFIX, addPrefix, getNumberFormatter } from '@encodable/format';
export const defaultNumberFormatResolver = getNumberFormatter;
export const defaultTimeFormatResolver = ({
  format,
  formatInLocalTime = false
} = {}) => {
  const formatString = formatInLocalTime ? addPrefix(LOCAL_TIME_PREFIX, format ?? getTimeFormatterRegistry().getDefaultKey()) : format;
  return getTimeFormatter(formatString);
};
export const defaultColorSchemeResolver = ({
  name,
  type = 'categorical'
} = {}) => getColorSchemeRegistry()[type].get(name);
export const defaultCategoricalColorScaleResolver = ({
  name,
  namespace
} = {}) => getScale(name, namespace);